import { Instagram, Facebook } from "lucide-react";

export const SocialLinks = ({ instagram, facebook, className = "" }) => {
  if (!instagram && !facebook) return null;
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {instagram && (
        <a
          data-testid="social-link-instagram"
          href={instagram}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="text-white/70 hover:text-twp-gold transition-colors"
        >
          <Instagram size={18} />
        </a>
      )}
      {facebook && (
        <a
          data-testid="social-link-facebook"
          href={facebook}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="text-white/70 hover:text-twp-gold transition-colors"
        >
          <Facebook size={18} />
        </a>
      )}
    </div>
  );
};
